import _ from "lodash";

import {
  FETCH_NOLs,
  FETCH_NOL,
  EDIT_NOL,
  CREATE_NOL,
  DELETE_NOL,
} from "../../actions/types";

const natureOfLossReducers = (state = {}, action) => {
  switch (action.type) {
    case FETCH_NOLs:
      return { ...state, ..._.mapKeys(action.payload, "id") };
    case FETCH_NOL:
      return { ...state, [action.payload.id]: action.payload };
    case EDIT_NOL:
      return { ...state, [action.payload.id]: action.payload };
    case CREATE_NOL:
      return { ...state, [action.payload.id]: action.payload };
    case DELETE_NOL:
      return _.omit(state, action.payload);

    default:
      return state;
  }
};

export default natureOfLossReducers;
